/* USERS */
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"

/**
 * add user
 */
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

/**
 * Edit user
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Delete user
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

/*
 * Account
*/
export const GET_ACCOUNT = "GET_ACCOUNT"
export const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS"
export const GET_ACCOUNT_ERROR = "GET_ACCOUNT_ERROR"

export const RESEND_USER_INVITE = "RESEND_USER_INVITE"
export const RESEND_USER_INVITE_SUCCESS = "RESEND_USER_INVITE_SUCCESS"
export const RESEND_USER_INVITE_ERROR = "RESEND_USER_INVITE_ERROR"
export const RESET_USER_INVITE_SENT_TO = "RESET_USER_INVITE_SENT_TO"

export const GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS = "GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS";
export const GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS = "GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS";
export const GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR = "GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR";

export const GET_CAMPAIGNS_BY_ACCOUNT = 'GET_CAMPAIGNS_BY_ACCOUNT';
export const GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS = 'GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS';
export const GET_CAMPAIGNS_BY_ACCOUNT_ERROR = 'GET_CAMPAIGNS_BY_ACCOUNT_ERROR';

export const GET_AD_GROUPS_BY_CAMPAIGN = 'GET_AD_GROUPS_BY_CAMPAIGN';
export const GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS = 'GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS';
export const GET_AD_GROUPS_BY_CAMPAIGN_ERROR = 'GET_AD_GROUPS_BY_CAMPAIGN_ERROR';

/*
 * campaign spends
*/
export const GET_CAMPAIGN_SPENDS = "GET_CAMPAIGN_SPENDS"
export const GET_CAMPAIGN_SPENDS_SUCCESS = "GET_CAMPAIGN_SPENDS_SUCCESS"
export const GET_CAMPAIGN_SPENDS_ERROR = "GET_CAMPAIGN_SPENDS_ERROR"

export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES';
export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS';
export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR';

export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT';
export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS';
export const GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR = 'GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR';

export const GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS = 'GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS';
export const GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS = 'GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS';
export const GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR = 'GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR';
